import styled from 'styled-components/macro'
import { CSSProperties } from 'react'

interface TabsProps<T> {
  tabs: {
    key: T
    title: string | React.JSX.Element
    disabled?: boolean
  }[]
  selectedTab: T
  setSelectedTab: (tab: T) => void
  style?: CSSProperties
  tabStyle?: CSSProperties
  isSmall?: boolean
  selectedColor?: string
  noGap?: boolean
}

export function Tabs<T>({
  tabs,
  selectedTab,
  setSelectedTab,
  style,
  tabStyle,
  isSmall,
  selectedColor,
  noGap,
}: TabsProps<T>) {
  return (
    <TabContainer $noGap={noGap} style={style}>
      {tabs.map(({ key, title, disabled }) => (
        <Tab
          key={String(key)}
          onClick={() => !disabled && setSelectedTab(key as T)}
          style={tabStyle}
          $isActive={selectedTab === key ? 1 : 0}
          $isSmall={isSmall ? 1 : 0}
          $isGrey={disabled}
          $selectedColor={selectedColor}
        >
          {title}
        </Tab>
      ))}
    </TabContainer>
  )
}

const TabContainer = styled.div<{ $noGap?: boolean }>`
  display: flex;
  align-items: flex-start;
  width: 100%;
  border-bottom: 1px solid #eaecf0;
  flex-direction: row;
  gap: ${(props) => (props.$noGap ? '0' : '25px')};
`

const Tab = styled.div<{
  $isActive: number
  $isSmall: number
  $isGrey?: boolean
  $selectedColor?: string
}>`
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: ${(props) => (props.$isSmall === 1 ? '13px' : '14px')};
  font-style: normal;
  font-weight: ${(props) =>
    props.$isActive === 1 ? (props.$isSmall ? '400' : '500') : '300'};
  text-underline-offset: 12px;
  line-height: 20px;
  border-bottom: ${(props) =>
    props.$isActive === 1
      ? `2px solid ${props.$selectedColor || 'currentColor'}`
      : 'none'};
  padding: ${(props) => (props.$isSmall === 1 ? '3px 10px' : '6px 12px')};
  cursor: pointer;
  white-space: nowrap;
  opacity: ${(props) => (props.$isGrey ? 0.5 : 1)};

  // Disable text selection
  -webkit-user-select: none; /* Safari */
  -ms-user-select: none; /* IE 10 and IE 11 */
  user-select: none; /* Standard syntax */

  &.selected {
    border-bottom: 2px solid ${(props) => props.$selectedColor || '#3c5e19'};
  }

  &:hover {
    border-bottom: 2px solid
      ${(props) => props.$selectedColor || 'currentColor'};
  }
`
